const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    title: {
      type: 'string',
      title: 'عنوان',
    },
    unit_id: {
      type: 'string',
      title: 'سازمان',
    },
    total_amount: {
      type: 'number',
      title: 'سقف بن',
      minimum: 0,
    },
    is_active: {
      type: 'number',
      title: 'فعالیت',
      oneOf: [
        { const: 1, title: 'فعال' },
        { const: 0, title: 'غیرفعال' },
      ],
    },
  },
});

export default schema;
